import {
	currentPeriodType,
	getPeriodTypeFromId,
} from "../../period/PeriodType.js";
import {
	defaultAccountOperation,
	getFormattedValue,
	makeAccountOperation,
	nameLabel,
	valueLabel,
} from "./helpers.js";
import AccountFormulaToken from "../../keyFigure/formulaToken/AccountFormulaToken.js";
import ConstantFormulaNode from "../../keyFigure/formula/ConstantFormulaNode.js";
import KeyFigure from "../../keyFigure/KeyFigure.js";
import MultiplicationFormulaNode from "../../keyFigure/formula/MultiplicationFormulaNode.js";

const defaultPeriodType = currentPeriodType;

/**
 * Todo: Add JSDoc comment
 */
export default function getAccountInputValueSpec({
	makeAccountPopover,
	getPeriod,
	keyFigureCalculationService,
	getAccountByNumber,
	isBimesterEnabled,
}) {
	return {
		type: "account",
		attributes: ["id"],
		optionalAttributes: {
			shift: 0,
			shiftPeriodType: defaultPeriodType.getId(),
			periodType: defaultPeriodType.getId(),
			precision: "default",
			display: "value",
			showAccountNumber: false,
			switchSign: false,
			valueType: defaultAccountOperation,
		},
		makePopover: setupPopover({
			makeAccountPopover,
			getPeriod,
			isBimesterEnabled,
		}),
		getValue,
		getTitle: ({ account }) => account.getName(),
		fetcher: async ({
			id: accountNumber,
			shift: shiftAsString,
			shiftPeriodType: shiftPeriodTypeId,
			periodType: periodTypeId,
			display,
			precision,
			showAccountNumber,
			switchSign,
			valueType,
		}) => {
			const shift = +shiftAsString;
			const shiftPeriodType = getPeriodTypeFromId(shiftPeriodTypeId);
			const periodType = getPeriodTypeFromId(periodTypeId);
			const account = getAccountByNumber(accountNumber);

			const data = {
				account,
				display,
				precision,
				shift,
				shiftPeriodType,
				periodType,
				showAccountNumber,
				switchSign,
				valueType,
			};

			data.name = showAccountNumber
				? account.toString()
				: account.getName();

			if (display === nameLabel) {
				return data;
			}

			const result = await fetchValue({
				data,
				getPeriod,
				keyFigureCalculationService,
			});

			data.value = result.getValues()[0];

			return data;
		},
	};
}

function fetchValue({ data, getPeriod, keyFigureCalculationService }) {
	return keyFigureCalculationService.fetchKeyFigureResult({
		periods: [getPeriod()],
		keyFigure: makeShiftedAccount(data),
	});
}

function getValue({ name, value, display, precision }) {
	if (display === nameLabel) {
		return name.toString();
	}

	const formattedValue = getFormattedValue({ value, precision });

	if (display === valueLabel) {
		return formattedValue;
	}

	return `${name}: ${formattedValue}`;
}

function makeShiftedAccount({
	account,
	shift,
	shiftPeriodType,
	periodType,
	switchSign,
	valueType,
}) {
	const keyFigure = new KeyFigure();
	let formulaNode = new AccountFormulaToken({
		accountNumber: account.getNumber(),
		shift,
		shiftPeriodType,
		periodType,
	}).asFormulaNode();

	formulaNode = makeAccountOperation({
		type: valueType,
		expression: formulaNode,
	});

	if (switchSign) {
		formulaNode = new MultiplicationFormulaNode({
			leftOperand: new ConstantFormulaNode({ value: -1 }),
			rightOperand: formulaNode,
		});
	}

	keyFigure.setFormula(formulaNode);

	return keyFigure;
}

function setupPopover({ makeAccountPopover, getPeriod, isBimesterEnabled }) {
	if (!makeAccountPopover) {
		return undefined;
	}

	return ({ updateNodeAttributes, getTriggerItem, content }) =>
		makeAccountPopover({
			getPeriod,
			isBimesterEnabled,
			defaultPeriodType,
			updateNodeAttributes,
			getTriggerItem,
			content,
		});
}
